import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Stack,
  Button,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { useTranslation } from "react-i18next";

export default function ReturnsSection({
  formData,
  handleText,
  setArrayItem,
  addArrayItem,
  removeArrayItem,
}) {
  const { t } = useTranslation("products");
  const itensEsq = Array.isArray(formData.trocas_itens) ? formData.trocas_itens : [];
  const passosDir = Array.isArray(formData.trocas_passos) ? formData.trocas_passos : [];

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.returnsTitle")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          {/* Alerta e descrição resumida */}
          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.returnsNotice")}
              name="trocas_alerta"
              value={formData.trocas_alerta || ""}
              onChange={handleText}
              fullWidth
              placeholder={t("form.returnsNoticePh")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.returnsProcess")}
              name="trocas_descricao"
              value={formData.trocas_descricao || ""}
              onChange={handleText}
              fullWidth
              placeholder={t("form.returnsProcessPh")}
            />
          </Grid>

          {/* Coluna ESQUERDA: título + itens (bullets) */}
          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.returnsColLeft")}
              name="trocas_col_esq"
              value={formData.trocas_col_esq || ""}
              onChange={handleText}
              fullWidth
              sx={{ mb: 1 }}
              placeholder={t("form.returnsColLeftPh")}
            />

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
              <strong>{t("form.returnsBullets")}</strong>
              <Button
                size="small"
                startIcon={<AddRoundedIcon />}
                onClick={() => addArrayItem("trocas_itens", "")}
              >
                {t("form.addItem")}
              </Button>
            </Stack>

            <Stack spacing={1.25}>
              {itensEsq.length === 0 && (
                <Divider textAlign="center" sx={{ color: "text.secondary", mb: 1 }}>
                  {t("form.noItems")}
                </Divider>
              )}
              {itensEsq.map((val, idx) => (
                <Stack key={idx} direction="row" alignItems="center" spacing={1}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder={t("form.itemPlaceholder", { n: idx + 1 })}
                    value={val}
                    onChange={(e) => setArrayItem("trocas_itens", idx, e.target.value)}
                  />
                  <Tooltip title={t("form.remove")}>
                    <IconButton onClick={() => removeArrayItem("trocas_itens", idx)} size="small">
                      <DeleteRoundedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              ))}
            </Stack>
          </Grid>

          {/* Coluna DIREITA: título + passos (lista ordenada) */}
          <Grid item xs={12} md={6}>
            <TextField
              label={t("form.returnsColRight")}
              name="trocas_col_dir"
              value={formData.trocas_col_dir || ""}
              onChange={handleText}
              fullWidth
              sx={{ mb: 1 }}
              placeholder={t("form.returnsColRightPh")}
            />

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
              <strong>{t("form.returnsSteps")}</strong>
              <Button
                size="small"
                startIcon={<AddRoundedIcon />}
                onClick={() => addArrayItem("trocas_passos", "")}
              >
                {t("form.addStep")}
              </Button>
            </Stack>

            <Stack spacing={1.25}>
              {passosDir.length === 0 && (
                <Divider textAlign="center" sx={{ color: "text.secondary", mb: 1 }}>
                  {t("form.noSteps")}
                </Divider>
              )}
              {passosDir.map((val, idx) => (
                <Stack key={idx} direction="row" alignItems="center" spacing={1}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder={t("form.stepPlaceholder", { n: idx + 1 })}
                    value={val}
                    onChange={(e) => setArrayItem("trocas_passos", idx, e.target.value)}
                  />
                  <Tooltip title={t("form.remove")}>
                    <IconButton onClick={() => removeArrayItem("trocas_passos", idx)} size="small">
                      <DeleteRoundedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
